import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0 } from "../../lib/format";
import { Modal, Notice, Pager } from "../../lib/ui";

/* Employee directory – port of addEmployee.php (API: /api/hr/employees). "Register employee" opens employerAdd. */

const COLS = [["client_name", "Employee"], ["position", "Position"], ["hire_date", "Hired"], ["status", "Status"], ["salary", "Salary", true]];

export default function Employees({ user }) {
  const admin = user?.role === "admin";
  const [change, setChange] = useState(null);
  const [notice, setNotice] = useState(null);
  const api = useApi();
  const [q, setQ] = useState({ page: 1, sort: "staff_id", order: "ASC", search: "" });
  const [term, setTerm] = useState("");
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async (p) => { try { setD(await api.get("/api/hr/employees", p)); } catch (e) { setError(e.message); } }, [api]);
  useEffect(() => { load(q); }, [load, q]);
  useEffect(() => { const t = setTimeout(() => setQ((s) => (s.search === term ? s : { ...s, search: term, page: 1 })), 300); return () => clearTimeout(t); }, [term]);
  const sortBy = (k) => setQ((s) => ({ ...s, sort: k, order: s.sort === k && s.order === "ASC" ? "DESC" : "ASC", page: 1 }));
  return (
    <main className="pg" style={{ maxWidth: "88rem" }}>
      <PageHeader slug="addEmployee" actions={<Link to="/employerAdd" className="btn primary"><i className="fas fa-user-plus" /> Register employee</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <section className="panel">
        <div className="toolbar"><div className="field grow"><div className="search"><i className="fas fa-magnifying-glass" />
          <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search name, position, status" aria-label="Search employees" /></div></div>
          {d && <span style={{ alignSelf: "center", fontSize: ".8rem", color: "var(--muted)" }}>{d.total} employees</span>}</div>
        <div className="tbl-wrap"><table className="tbl">
          <thead><tr>{COLS.map(([k, l, num]) => <th key={k} className={`sortable ${num ? "num" : ""}`} onClick={() => sortBy(k)}>{l} {q.sort === k && <i className={`fas ${q.order === "ASC" ? "fa-sort-up" : "fa-sort-down"}`} />}</th>)}
            <th>Next of kin</th><th>Education</th><th className="num">Leave taken</th>{admin && <th />}</tr></thead>
          <tbody>{d?.rows.map((r) => (
            <tr key={r.staff_id}>
              <td><span style={{ display: "inline-flex", alignItems: "center", gap: ".5rem", fontWeight: 600, color: "var(--ink)" }}><span className="avatar">{(r.client_name || "?").charAt(0)}</span>{r.client_name || `Staff #${r.staff_id}`}</span></td>
              <td>{r.position}</td><td>{r.hire_date || "–"}</td>
              <td><span className={`pill-tag ${String(r.status).toLowerCase() === "active" ? "ok" : ""}`}>{r.status}</span></td>
              <td className="num mono">{n0(r.salary)}</td>
              <td>{r.next_of_kin_name || "–"}{r.next_of_kin_phone && <div style={{ fontSize: ".75rem", color: "var(--muted)" }}>{r.next_of_kin_phone}</div>}</td>
              <td>{r.highest_degree || "–"}{r.highest_institution && <div style={{ fontSize: ".75rem", color: "var(--muted)" }}>{r.highest_institution}</div>}</td>
              <td className="num mono">{r.approved_leave_count}</td>
              {admin && <td style={{ whiteSpace: "nowrap" }}>{String(r.status) === "Active"
                ? <button type="button" className="btn sm" onClick={() => setChange({ r, status: "Inactive" })}><i className="fas fa-user-slash" /> Disable</button>
                : <button type="button" className="btn sm primary" onClick={() => setChange({ r, status: "Active" })}><i className="fas fa-user-check" /> Enable</button>}</td>}
            </tr>))}</tbody>
        </table>{d && d.rows.length === 0 && <div className="empty"><i className="fas fa-users" />No employees found.</div>}</div>
        {d && <Pager page={d.page} totalPages={d.pages} onPage={(p) => setQ({ ...q, page: p })} />}
      </section>
      {change && (
        <Modal title={change.status === "Active" ? "Enable this employee?" : "Disable this employee?"} onClose={() => setChange(null)}
          actions={<><button type="button" className="btn" onClick={() => setChange(null)}>Cancel</button>
            <button type="button" className={`btn ${change.status === "Active" ? "primary" : "danger"}`} onClick={async () => {
              const c = change; setChange(null);
              try { const x = await api.post(`/api/hr/employees/${c.r.staff_id}/status`, { status: c.status }); setNotice({ tone: "ok", text: `${c.r.client_name}: ${x.message}` }); load(q); }
              catch (e) { setNotice({ tone: "err", text: e.message }); } }}>{change.status === "Active" ? "Enable" : "Disable"}</button></>}>
          {change.status === "Active"
            ? <><b>{change.r.client_name}</b> will be included in payroll again and can request leave.</>
            : <>{change.r.client_name} won't be included in payroll (generate, verify or authorise) and can't request leave. Their history, payslips and leave records are kept.</>}
        </Modal>
      )}
    </main>
  );
}
